module.exports = __webpack_public_path__ + "static/media/jasper-18.4007efa5.jpg";